import React, { Component } from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { fetchAllContents } from 'actions/learn/contents';
import { createStore } from 'stores/learn';
import { routes } from 'constants/config';
import ScrollToTop from 'components/shared/ScrollToTop';
import Layout from './shared/Layout';
import Content from './Content';
import Search from './Search';
import Header from './Header';

class Learn extends Component {
  constructor(props) {
    super(props);
    this.store = createStore(props);
  }

  componentDidMount() {
    this.store.dispatch(fetchAllContents());
  }

  render() {
    return (
      <Provider store={this.store}>
        <Router>
          <ScrollToTop>
            <Layout.Dashboard>
              <Header />
              <Switch>
                <Route path={routes.LEARN_SEARCH} component={Search} />
                <Route component={Content} />
              </Switch>
            </Layout.Dashboard>
          </ScrollToTop>
        </Router>
      </Provider>
    );
  }
}

export default Learn;
